export default __webpack_public_path__ + "static/media/chip10000.df1e7240.png";